import { IViolationMaterialType } from 'APIPackage/CatalogsModule/interfaces/IViolationMaterialType';
import { IViolationMaterialTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IViolationMaterialTypeSelectOption';

export function createViolationMaterialTypeSelectOption(
  violationMaterialType: IViolationMaterialType,
): IViolationMaterialTypeSelectOption {
  return {
    ...violationMaterialType,
    label: violationMaterialType.title,
    value: violationMaterialType.code,
  };
}
